import React, { Component } from "react";
import staticDataAction from "../../../redux/staticData/staticDataAction";
import { withRouter } from "../../../withRouter";
import { Static_Url } from "../../../provider/ServiceUrl";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import SelectedTabAction from "../../../redux/selectedTab/SelectedTabAction";
import headerAction from "../../../redux/header/headerAction";
import CrmIntegrationAction from "../../../redux/crmIntegration/CrmIntegrationAction";
import AccountSettingDataAction from "../../../redux/accountSetting/AccountSettingDataAction";
import store from "../../../redux/store";
import FetchServerData from "../../../provider/FetchServerData";

class AccessDpTextAccount extends Component {
    constructor(props) {
        super(props);
        const str = new URLSearchParams(window.location.search);
        const sessionId = str.get("s");
        const accountId = str.get("a");
        if (sessionId && accountId) {
            this.accessDpTextAccount(accountId, sessionId);
        }

        this.state = {};
    }

    accessDpTextAccount(accountId, sessionId) {
        const postObject = {
            sessionId: sessionId,
            accountId: accountId,
        };
        FetchServerData.callPostService("/apAccountms/accessDpTextAccount", postObject).then(
            (response) => {
                if (response.status === "SUCCESS") {
                    let output = response.data;
                    this.processLoginSuccess(output);
                }
            }
        );
    }

    async processLoginSuccess(output_data) {
        await this.setStaticData(output_data.header);
        store.dispatch(headerAction.setHeader(output_data.header));
        store.dispatch(AppUserDataAction.setUserData(output_data));
        store.dispatch(AppUserDataAction.setUsage(output_data.smsCredits));
        store.dispatch(AppUserDataAction.setTollfreeNumber(output_data.tollfreeNumber));
        store.dispatch(AppUserDataAction.setTollfreeNumberStatus(output_data.tollFreeNumberStatus));
        store.dispatch(
            CrmIntegrationAction.setCrmIntegration(output_data.crmIntegration)
        );
        store.dispatch(
            AppUserDataAction.setOrganization(output_data.appuser?.organization)
        );
        let accountSetting = output_data?.accountSetting;
        store.dispatch(AccountSettingDataAction.setAccountSettingData({ accountSetting }));

        let logoData = {
            logo: output_data.appuser?.organization?.logo
                ? output_data.appuser?.organization?.logo
                : "",
            logoFilename: output_data.appuser?.organization?.logoFilename
                ? output_data.appuser?.organization?.logoFilename
                : "",
            logoFileextension: output_data.appuser?.organization?.logoFileextension
                ? output_data.appuser?.organization?.logoFileextension
                : "",
        };
        store.dispatch(AppUserDataAction.setLogo(logoData));
        if (output_data.isTollfreeNumberPurchased === true) {
            store.dispatch(SelectedTabAction.setSelectedTab(0));
        } else {
            store.dispatch(SelectedTabAction.setSelectedTab(1));
            if (output_data.cmpaigningInfoError) {
            }
        }
        let header = output_data.header;
        this.loadDashboardPage(header, output_data);
    }

    loadDashboardPage(header, output) {
        let menus = output?.appuser.profile?.menus.sort(
            (a, b) => a.displaysequence - b.displaysequence
        );
        store.dispatch(ActiveMenuAction.setActiveMenu(menus[0]?.pageid));
        for (let i = 0; i < menus.length; i++) {
            const menu = menus[i];
            if (menu.isactive) {
                this.props.navigate(menu.pageid);
                break;
            }
        }
    }
    async setStaticData(header) {
        const postObject = {
            header: header,
        };

        FetchServerData.callPostService(Static_Url, postObject).then(
            (output) => {
                if (output.status === "SUCCESS") {
                    store.dispatch(staticDataAction.setStaticData(output.data));
                }
            }
        );
    }
    render() {
        return <div></div>;
    }
}
export default withRouter(AccessDpTextAccount);
